export const UTM_PARAMS = [
  { value: 'utm_campaign', label: 'UTM Campaign' },
  { value: 'utm_medium', label: 'UTM Medium' },
  { value: 'utm_source', label: 'UTM Source' },
  { value: 'utm_content', label: 'UTM Content' },
  { value: 'utm_term', label: 'UTM Term' },
  { value: 'src', label: 'SRC (Source)' },
  ...Array.from({ length: 20 }, (_, i) => ({ value: `sub${i + 1}`, label: `Sub ${i + 1}` })),
];

export const MAIN_GROUP_KEYS = [
  'utm_campaign',
  'utm_medium',
  'utm_source',
  'utm_content',
  'utm_term',
  'src',
];

export const DESCRIPTION_MAP: Record<string, string> = {
  utm_campaign: 'utmPanel.campaign_desc',
  utm_medium: 'utmPanel.synced_desc',
  utm_source: 'utmPanel.synced_desc',
  utm_content: 'utmPanel.synced_desc',
  utm_term: 'utmPanel.synced_desc',
  src: 'utmPanel.src_desc',
};

export function getGroupDescription(key: string): string {
  return DESCRIPTION_MAP[key] || 'utmPanel.sub_desc';
}

export const FILTER_UTM_PANEL_MODAL = 'filter-utm-panel';

export const MULTI_VALUED_FILTER_KEYS = [
  'products',
  'offers',
  'checkouts',
  'affiliates',
  'coproducers',
  'templates',
] as const;

export const STRING_FILTER_KEYS = ['search_param', 'search_value'] as const;
